import getCurrentGuide from './getCurrentGuide';

export default function(type, step) {
    var currentGuide = getCurrentGuide(type);
    var currentGuideStepIndex = _.findIndex(currentGuide, {_step: step});
    var nextGuideStep = currentGuide[currentGuideStepIndex + 1];
    return nextGuideStep;
}